import React from 'react';

import { MdQuestionAnswer } from 'react-icons/md';

import {
  Container,
  Content,
  InstitutionsBox,
  InstitutionsBrands,
  FooterAns,
} from './styles';

// import brands
import logo_qualiss from '~/assets/img/brand/institutions/qualiss_logo_resized.PNG';
import logo_ans from '~/assets/img/brand/institutions/ans_logo_resized.png';
import logo_sihosp from '~/assets/logo.svg';

const Footer = () => {
  return (
    <Container id="rodape">
      <InstitutionsBox>
        <Content>
          <InstitutionsBrands>
            <div>
              <img
                src={logo_ans}
                alt="ANS – Agência Nacional de Saúde Suplementar"
              />
            </div>
            <br/>
            <div>
              <img
                src={logo_qualiss}
                alt="Quallis – Monitoramento de Qualidade Hospitalar"
              />
            </div>
            <br/>
            <div>
              <img
                src={logo_sihosp}
                alt="Sistema de Indicadores Hospitalares"
              />
            </div>
                      
          </InstitutionsBrands>
        </Content>
      </InstitutionsBox>

      <FooterAns>
        <Content>
          <div className="container-footer">
            <p>
              <strong>ANS - Agência Nacional de Saúde Suplementar - </strong>
              Av. Augusto Severo, 84 - Glória Rio de Janeiro/RJ - CEP: 20021-040
            </p>

            <span>
              <a
                href="http://www.ans.gov.br/planos-de-saude-e-operadoras/espaco-do-consumidor/central-de-atendimento-ao-consumidor"
                target="_blank"
                rel="noopener noreferrer"
                title="Central de Atendimento"
              >
                <MdQuestionAnswer />
                Central de Atendimento
              </a>
            </span>
          </div>
        </Content>
      </FooterAns>
    </Container>
  );
};

export default Footer;
